// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"228":"9886d57e","776":"274fcd80"}[chunkId] + ".chunk.js");